/** Gráfico radar compacto para composición de manada. */
export default function MiniRadar({
    data,
    labels,
    axes,
    size = 180,
    color = '#0f766e',
}) {
    const axisList =
        axes?.length > 0
            ? axes.map((a) => ({ label: a.label, color: a.color || color }))
            : (labels || []).map((label) => ({ label, color }));

    const cx = size / 2;
    const cy = size / 2;
    const radius = size * 0.34;
    const labelRadius = radius + 26;
    const levels = 4;
    const maxVal = Math.max(...data, 1);
    const n = data.length;

    const getPoint = (index, value) => {
        const angle = (Math.PI * 2 * index) / n - Math.PI / 2;
        const r = (value / maxVal) * radius;
        return { x: cx + r * Math.cos(angle), y: cy + r * Math.sin(angle) };
    };

    const gridLines = [];
    for (let l = 1; l <= levels; l++) {
        const pts = [];
        for (let i = 0; i < n; i++) {
            const p = getPoint(i, (maxVal / levels) * l);
            pts.push(`${p.x},${p.y}`);
        }
        gridLines.push(pts.join(' '));
    }

    const dataPoints = data.map((v, i) => getPoint(i, v));
    const dataPath = dataPoints.map((p) => `${p.x},${p.y}`).join(' ');

    const labelPoints = axisList.map((axis, i) => {
        const angle = (Math.PI * 2 * i) / n - Math.PI / 2;
        return {
            x: cx + labelRadius * Math.cos(angle),
            y: cy + labelRadius * Math.sin(angle),
            label: axis.label,
            color: axis.color,
        };
    });

    return (
        <svg
            viewBox={`0 0 ${size} ${size}`}
            className="mini-radar-svg"
            role="img"
            aria-label="Radar de arquetipos ALINEA"
        >
            {gridLines.map((pts, i) => (
                <polygon
                    key={i}
                    points={pts}
                    fill="none"
                    stroke="rgba(100, 116, 139, 0.15)"
                    strokeWidth="0.5"
                />
            ))}
            {axisList.map((axis, i) => {
                const p = getPoint(i, maxVal);
                return (
                    <line
                        key={i}
                        x1={cx}
                        y1={cy}
                        x2={p.x}
                        y2={p.y}
                        stroke={axis.color}
                        strokeOpacity="0.35"
                        strokeWidth="1"
                    />
                );
            })}
            <polygon points={dataPath} fill={`${color}22`} stroke={color} strokeWidth="1.5" />
            {dataPoints.map((p, i) => (
                <circle
                    key={i}
                    cx={p.x}
                    cy={p.y}
                    r="4"
                    fill={axisList[i]?.color || color}
                    stroke="#fff"
                    strokeWidth="1"
                />
            ))}
            {labelPoints.map((p, i) => (
                <text
                    key={i}
                    x={p.x}
                    y={p.y}
                    textAnchor="middle"
                    dominantBaseline="central"
                    fill={p.color}
                    fontSize="9"
                    fontWeight="700"
                >
                    {p.label}
                </text>
            ))}
        </svg>
    );
}
